import styled from 'styled-components';

export const StyledAddIcon = styled.svg`
    background: none;
    border: none;
    cursor: pointer;
`;
